<template>
  <Transition
    enter-from-class="translate-y-full scale-y-0"
    enter-to-class="translate-y-0 scale-y-100"
    :enter-active-class="`transform transition duration-100 ease-out`"
    leave-from-class="translate-y-0 scale-y-100"
    leave-to-class="translate-y-full scale-y-100"
    :leave-active-class="`transform transition duration-100 ease-in`"
    appear
  >
    <div
      v-if="isMobile && isCtaFabShown"
      class="fixed inset-x-0 bottom-0 z-10 border-t border-black-20 bg-white p-2 transition-all duration-200"
    >
      <Button
        id="add-to-basket"
        data-test-id="add-item-to-basket-button"
        no-padding
        type="primary"
        class="w-full grow border-0 bg-black py-2"
        :class="{ 'cursor-not-allowed': product.isSoldOut }"
        :disabled="!(canPurchase && canPurchaseMultiple)"
        :title="!canPurchase ? $t('badge_labels.sold_out') : ''"
        ignore-capitalisation
        data-qa="add-to-cart"
        @click="handleCtaFabClick"
        @touchstart="handleCtaFabClick"
      >
        <span v-if="product.isSoldOut">{{ $t('pdp.add_label') }}</span>
        <span v-else-if="activeVariant">{{ $t('pdp.add_label') }}</span>
        <span v-else>{{ $t('pdp.size_picker.choose_size') }}</span>
      </Button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import type { Product, Variant } from '@scayle/storefront-nuxt'
import { useEventListener, useDebounceFn } from '@vueuse/core'
import { useDeviceType } from '~/composables/useDeviceType'
import {
  useBasketHandling,
  type UseBasketHandlingProps,
} from '../../../../../composables/useBasketHandling'

export type PdpCtaProps = {
  activeVariant: Variant | undefined
  product: Product
}

const props = defineProps<UseBasketHandlingProps>()

const { addItemToBasket, canPurchase, canPurchaseMultiple, isInBasket } =
  useBasketHandling(props)

const { isMobile } = useDeviceType()

const isCtaFabShown = ref(false)

const handleCtaFabClick = () => {
  if (props.activeVariant) {
    return addItemToBasket()
  }
  document.getElementById('product-size-picker')?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  })
}

function isElementBelowViewport(element: HTMLElement) {
  const rect = element.getBoundingClientRect()
  return (
    rect.bottom > (window.innerHeight || document.documentElement.clientHeight)
  )
}

const onScroll = () => {
  const element = document?.getElementById('add-to-basket')
  const IsBelowViewport = !element || isElementBelowViewport(element)
  isCtaFabShown.value = IsBelowViewport && !isInBasket.value
}

useEventListener('scroll', useDebounceFn(onScroll, 5))
onMounted(onScroll)
</script>
